import type { HTMLAttributes, ReactNode } from 'react'

import styles from './Field.module.css'

export interface FieldProps extends HTMLAttributes<HTMLDivElement> {
  label: ReactNode
  mutedLabel?: ReactNode
  hint?: ReactNode
  error?: ReactNode
  auxiliary?: ReactNode
}

export function Field({ label, mutedLabel, hint, error, auxiliary, children, className = '', ...props }: FieldProps) {
  return (
    <div className={`${styles.field} ${className}`} {...props}>
      <div className={styles.labelRow}>
        <label className={styles.label}>{label}{mutedLabel ? <span className={styles.muted}>{mutedLabel}</span> : null}</label>
        {hint ? <span className={styles.hint}>{hint}</span> : null}
      </div>
      {children}
      {error ? <p className={styles.error}>{error}</p> : null}
      {auxiliary ? <p className={styles.aux}>{auxiliary}</p> : null}
    </div>
  )
}
